<script lang="ts">
/**
 * Dashboard section showing recently added items.
 *
 * Renders a labeled list of compact item rows with a "See all" link
 * to the full items index.
 *
 * @example
 * ```vue
 * <RecentItemsSection :items="recent_items" />
 * ```
 */
export interface RecentItemsSectionProps {
  /** Recent items from the backend. */
  items: ItemSummary[]
}
</script>

<script setup lang="ts">
import { SbSectionedList } from "@unio/saltbox-ui"

import ListItemRow from "@/components/ListItemRow.vue"
import { itemsPath } from "@/routes"
import type { ItemSummary } from "@/types/models"

defineProps<RecentItemsSectionProps>()
</script>

<template>
  <SbSectionedList label="Recent Items">
    <template #trailing>
      <UButton
        label="See all"
        variant="link"
        color="primary"
        trailing-icon="i-lucide-arrow-right"
        size="sm"
        :to="itemsPath()"
      />
    </template>
    <ListItemRow v-for="item in items" :key="item.id" :item="item" variant="compact" />
  </SbSectionedList>
</template>
